(function () {
  "use strict";

  const ROOT_SELECTOR = "[data-easy-btn]";
  const MOBILE_MQ = "(max-width: 720px)";
  const DESIGN_PC = 2560;
  const DESIGN_M = 720;
  const FREEZE_PC = 1200;
  const FREEZE_M = 560;

  function spaceBetween() {
    var mobile = window.matchMedia(MOBILE_MQ).matches;
    if (mobile) {
      var mobileVw = Math.max(window.innerWidth, FREEZE_M);
      return Math.min((12 * mobileVw) / DESIGN_M, 12);
    }
    var pcVw = Math.max(window.innerWidth, FREEZE_PC);
    return Math.min((24 * pcVw) / DESIGN_PC, 24);
  }

  function offsetAfter(swiperEl) {
    var slide = swiperEl.querySelector(".easy-btn-slide");
    if (!slide) return 0;
    var swiperW = swiperEl.clientWidth;
    var cardW = slide.getBoundingClientRect().width;
    return Math.max(0, swiperW - cardW);
  }

  function setActive(section, index) {
    section.querySelectorAll("[data-easy-btn-progress]").forEach(function (bar, barIndex) {
      var active = barIndex === index;
      bar.classList.toggle("is-active", active);
      bar.setAttribute("aria-selected", active ? "true" : "false");
    });
  }

  function destroySwiper(section) {
    if (section.__easyBtnSwiper) {
      section.__easyBtnSwiper.destroy(true, true);
      section.__easyBtnSwiper = null;
    }
  }

  function initSection(section) {
    if (!section || typeof Swiper === "undefined") return;

    var swiperEl = section.querySelector("[data-easy-btn-swiper]");
    var bars = Array.from(section.querySelectorAll("[data-easy-btn-progress]"));
    if (!swiperEl || bars.length === 0) return;

    destroySwiper(section);

    var swiper = new Swiper(swiperEl, {
      slidesPerView: "auto",
      spaceBetween: spaceBetween(),
      slidesOffsetAfter: offsetAfter(swiperEl),
      speed: 500,
      autoHeight: false,
      allowTouchMove: true,
      simulateTouch: true,
      grabCursor: true,
      watchOverflow: false,
      observer: false,
      observeParents: false,
      on: {
        init: function (instance) {
          setActive(section, instance.activeIndex);
        },
        slideChange: function (instance) {
          setActive(section, instance.activeIndex);
        },
      },
    });

    section.__easyBtnSwiper = swiper;

    bars.forEach(function (bar, index) {
      bar.addEventListener("click", function () {
        if (section.__easyBtnSwiper && !section.__easyBtnSwiper.destroyed) {
          section.__easyBtnSwiper.slideTo(index);
        }
      });
    });
  }

  function updateAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(function (section) {
      if (!section.__easyBtnSwiper || section.__easyBtnSwiper.destroyed) return;
      var el = section.querySelector("[data-easy-btn-swiper]");
      section.__easyBtnSwiper.params.spaceBetween = spaceBetween();
      section.__easyBtnSwiper.params.slidesOffsetAfter = el ? offsetAfter(el) : 0;
      section.__easyBtnSwiper.update();
    });
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  var resizeFrame = 0;
  window.addEventListener("resize", function () {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(updateAll);
  });

  document.addEventListener("shopify:section:load", function (event) {
    var section =
      event.target.querySelector(ROOT_SELECTOR) || event.target.closest(ROOT_SELECTOR);
    if (section) initSection(section);
  });
})();
